import { render, staticRenderFns } from "./manage-recommendations.vue?vue&type=template&id=369f4cf2&"
import script from "./manage-recommendations.vue?vue&type=script&lang=js&"
export * from "./manage-recommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports